























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { ratingCellRenderer } from '@/helpers/ag-grid/cellRenderer'
import { REKORDCLOUD_COLOR_HEX_MAP } from '../../../../helpers/color'

@Component({})
export default class TrackResult extends Vue {
  detailsOpen: boolean = false

  @Prop()
  track: Track

  @Prop({
    default: null
  })
  wide: any

  @Prop()
  hasDetails: boolean

  get label(): string {
    let s: string = ''

    if (this.track.artist) s += `${this.track.artist} - `

    s += `${this.track.title}`

    return s
  }

  get ratingHtml(): string | null {
    return ratingCellRenderer({ data: { rating: this.track.rating } })
  }

  get colorHex(): string {
    if (!this.track.color) return ''

    return REKORDCLOUD_COLOR_HEX_MAP[this.track.color]
  }

  toggleDetails() {
    if (this.hasDetails) {
      this.detailsOpen = !this.detailsOpen
    }
  }

  setBaseTrack() {
    this.$emit('setBaseTrack', true)
  }

  moreLikeThis() {
    this.$emit('moreLikeThis', true)
  }
}
